<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'pcode'}">
              <a>個人コード一覧 </a>
            </router-link>
            <li class="active">個人コード編集</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>個人コード編集</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-danger" v-if="errorMessageLogs!==''">
            {{ errorMessageLogs }}
          </div>
          <div class="alert alert-success" v-if="message">
            {{ message }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <div class="col-md-offset-2 col-md-10"><span id="name_error" class="error_m"></span></div>
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">個人コード</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" disabled id="name" placeholder="個人コード" v-model="pcodeInfor.pCodeId">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">コード種別</label>
                <div class="col-sm-10">
                  <select class="form-control" data-placeholder="ユーザー選択" disabled v-model="pcodeInfor.type">
                    <option v-for="item in listType" v-bind:value="item.value" v-bind:key="item.value">
                      {{ item.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-10">
                  <button class="btn-cusstom green-btn" type="button" href="#userList" data-toggle="modal">ユーザーの選択</button>
                  <button class="btn-cusstom black-btn" type="button" @click="removeUser()">ユーザーの関連付け解除</button>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ユーザーID</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" id="name" disabled placeholder="ユーザーID" v-model="pcodeInfor.userId">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ユーザー名</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" id="name" disabled placeholder="ユーザー名" v-model="pcodeInfor.name">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ステータス</label>
                <div class="col-sm-1">
                  <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="pcodeInfor.isValid">
                  <span class="lbl"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-10">
                  <router-link :to="{ name: 'pcode'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="editPcode()">
                    保存
                  </button>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <div id="userList" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">ユーザーの関連付けを追加</h3>
            <span class="input-icon search-box">
              <input type="text" placeholder="ユーザーID、ユーザー名検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
              <i class="ace-icon fa fa-search nav-search-icon"></i>
            </span>
            <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
          </div>
          <div class="modal-body">
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="listUser!=null">
              <thead>
                <tr>
                  <th></th>
                  <th>ユーザーID</th>
                  <th>ユーザー名</th>
                  <th class="center">ステータス</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in listUser" :key="index">
                <tr>
                  <td class="center">
                    <label class="pos-rel">
                      <input type="radio" class="ace" :value="item.userId" v-model="selectedUserId">
                      <span class="lbl"></span>
                    </label>
                  </td>
                  <td style="max-width:150px;word-wrap: break-word">
                    {{item.userId}}
                  </td>
                  <td style="max-width:150px;word-wrap: break-word">
                    {{item.name}}
                  </td>
                  <td class="center user_status">
                    <span v-if="item.isValid">有効</span>
                    <span v-else >無効</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
              <thead>
                <tr>
                  <th style="width:150px">ユーザーID</th>
                  <th>ユーザー名</th>
                  <th class="center">ステータス</th>
                </tr>
              </thead>
              <tbody>
                <tr><td colspan="3">データーはありません</td></tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div class="row pd-t-10">
              <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
                <paginate
                  :page-count="pages"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="handleCurrentChange"
                  :prev-text="'<<'"
                  :next-text="'>>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate>
              </div>
            </div>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" @click="addUserInfor()" data-dismiss="modal">選択</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      errorMessageLogs: '',
      pcodeInfor: {
        pCodeId: '',
        userId: '',
        name: '',
        type: 0,
        isValid: true
      },
      pCodeId: '',
      selectedUserId: '',
      listUser: null,
      listType: [
        { text: 'NFCカード', value: 0 },
        { text: 'テンキー入力', value: 1 }
      ],
      pages: 0,
      listQuery: {
        currPage: 1
      },
      success: false,
      isDisabled: false,
      flagU: false,
      flag: false,
      message: '',
      loading: false
    }
  },
  created () {
    var vm = this
    vm.getPcodeData()
  },
  mounted () {
    this.getListUser()
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
  },
  methods: {
    getPcodeData () {
      var vm = this
      var data = this.$route.query
      this.pCodeId = data.id
      this.$http.get(Config.PCODE_LIST_API + '?pCodeId=' + encodeURIComponent(this.pCodeId))
        .then(response => {
          vm.pcodeInfor.pCodeId = response.body.pCodes[0].pCodeId
          vm.pcodeInfor.userId = response.body.pCodes[0].userId
          vm.getUserInfor(response.body.pCodes[0].userId)
          vm.pcodeInfor.type = response.body.pCodes[0].type
          vm.pcodeInfor.isValid = response.body.pCodes[0].isValid
        })
        .catch(error => {
          console.log(error)
        })
    },
    getUserInfor (userId) {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          vm.pcodeInfor.name = response.body.users[0].name
        })
        .catch(error => {
          console.log(error)
        })
    },
    addUserInfor () {
      var vm = this
      this.loading = true
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(this.selectedUserId))
        .then(response => {
          vm.pcodeInfor.userId = response.body.users[0].userId
          vm.pcodeInfor.name = response.body.users[0].name
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    removeUser () {
      this.pcodeInfor.userId = ''
      this.pcodeInfor.name = ''
    },
    handleCurrentChange (val) {
      this.flag = true
      this.listQuery.currPage = val
      this.getListUser()
    },
    getListUser () {
      var keyword = $('.nav-search-input').val()
      keyword = keyword.replace(/\s/g, ',')
      this.$http.get(Config.USERS_LIST_API + '?limit=25&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=userId,name' + '&isValid=true&exclude=thumbnail')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.flag = false
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / 25)
            this.listUser = response.body.users
          } else {
            this.listUser = null
            this.pages = 0
            this.loading = false
          }
        })
        .catch((error) => {
          this.listUser = null
          this.pages = 0
          this.flag = false
          console.log(error)
        })
    },
    search () {
      this.loading = true
      var keyword = $('.nav-search-input').val()
      keyword = keyword.replace(/\s/g, ',')
      this.$http.get(Config.USERS_LIST_API + '?limit=' + 25 + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=userId,name' + '&isValid=true&exclude=thumbnail')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / 25)
            this.listUser = response.body.users
          } else {
            this.listUser = null
            this.pages = 0
            this.loading = false
          }
        })
        .catch((error) => {
          this.listUser = null
          this.loading = false
          console.log(error)
        })
    },
    editPcode () {
      this.loading = true
      this.message = ''
      this.errorMessageLogs = ''
      this.$http.put(Config.PCODE_LIST_API + '/' + encodeURIComponent(this.pCodeId), {isValid: this.pcodeInfor.isValid, userId: this.pcodeInfor.userId})
        .then(response => {
          if (response.body.message === 'Success') {
            this.loading = false
            this.errorMessageLogs = ''
            this.message = Config.EDIT_PCODE_API_SUCCESS
          } else {
            this.loading = false
            this.errorMessageLogs = Config.ADD_API_ERROR
            this.message = ''
          }
        })
        .catch((error) => {
          this.message = ''
          this.loading = false
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = '個人コードの編集権限がありません。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 420:
              this.errorMessageLogs = '個人コード登録数が上限に達しています。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>
<style>
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    border-radius: 10px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41!important
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
  .field{
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    background: #ABBAC3;
  }
</style>



// WEBPACK FOOTER //
// src/views/pcode/PcodeEdit.vue